import { GroupedItemType, ReactListProps } from '../types'
import './ReactCFGroupedStaticList.scss'

const ReactCFGroupedStaticList = (props: ReactListProps): JSX.Element => {
  const { groupedItems } = props

  const groupedItemsValue = []
  for (let i = 0; i < groupedItems?.value.length; i++) {
    const groupedItem = JSON.parse(groupedItems.value[i])
    groupedItem.bulletPoints = groupedItem.bulletPointsTxt.split(',')
    groupedItemsValue.push(groupedItem)
  }

  return (
    <div data-testid={`grouped-static-list-container`} className={`grouped-static-list-container`}>
      {groupedItemsValue?.length > 0 &&
        groupedItemsValue.map((groupedItem: GroupedItemType) => {
          const { title, iconPath, iconAltTxt, bulletPoints } = groupedItem
          return (
            <div className='grouped-list-item-container'>
              <div className='icon-section'>
                <img src={iconPath} alt={iconAltTxt} className='icon' />
              </div>
              <div className='list-section'>
                <p className='list-title'>{title}</p>
                <ul className='list'>
                  {bulletPoints.map((bulletItem: string, index: number) => {
                    return (
                      <li key={`bullet-item-${index}`} className='list-item'>
                        {bulletItem}
                      </li>
                    )
                  })}
                </ul>
              </div>
            </div>
          )
        })}
    </div>
  )
}

export default ReactCFGroupedStaticList
